import {
  getLeoDate,
  LeoDate,
} from "@surya-digital/leo-ts-types";

export interface DateRangeDTO {
  startDate: string;
  endDate: string;
}

export class DateRange {
  readonly isDateRangeDateRange: boolean = true;

  readonly startDate: LeoDate;
  readonly endDate: LeoDate;


  constructor(
  startDate: LeoDate, 
  endDate: LeoDate
  ) {
    this.startDate = startDate;
    this.endDate = endDate;
  }

  static fromDTO(dto: DateRangeDTO): DateRange {
    const startDate = getLeoDate(dto, "startDate", InvalidDateRangeStartDateError);
    const endDate = getLeoDate(dto, "endDate", InvalidDateRangeEndDateError);
    return new DateRange(
      startDate,
      endDate
    );
  }

  toDTO(): DateRangeDTO {
    const dto: DateRangeDTO = {
        startDate: this.startDate.toDTO(),
        endDate: this.endDate.toDTO()
    };
    return dto;
  }
  }

DateRange.prototype.toString = function toString(): string {
  return `DateRange(startDate='${this.startDate}',endDate='${this.endDate}')`;
};

export class InvalidDateRangeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDateRangeError";
  }
}
export class InvalidDateRangeStartDateError extends InvalidDateRangeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDateRangeStartDateError";
  }
}

export class InvalidDateRangeEndDateError extends InvalidDateRangeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDateRangeEndDateError";
  }
}
